/*
 * Keeps the HubSpot visitor ID from a tagged website link for the signup form submission.
 * The tracking script only loads after consent and starts a new visitor instead of adopting it.
 */

export default defineNuxtRouteMiddleware(to => {
  const hstc = getQueryParam<string>(to.query.__hstc)
  if (!hstc) return

  const visitorId = getHubspotVisitorId(hstc)
  if (!visitorId) return

  try {
    localStorage.setItem(HUBSPOT_VISITOR_ID_STORAGE_KEY, visitorId)
  } catch {
    /* Without storage the signup simply goes unattributed. */
  }
})
